"use strict";

export function debounce(callback, wait) {
  let timerId;
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    const context = this;
    timerId = setTimeout(function () {
      callback.apply(context, args);
    }, wait);
  };
}
